import { useEffect, useState } from 'react'
import { getExamsResults } from '../api/laboratories'
import { normalizeExamResultsList } from '../utils/normalizer/labsNormalizer'
import { usePaginate } from './useFilteredLabResults'

const inFlightRequestsByPatientERID = {}

export const useHomeLabResults = ({ patientERID }) => {
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const { paginatedResults } = usePaginate(data, 1, 10)

	useEffect(() => {
		if (!patientERID) {
			setData([])
			setLoading(false)
			setError(null)
			return
		}

		let isMounted = true
		setLoading(true)
		setError(null)

		if (!inFlightRequestsByPatientERID[patientERID]) {
			const postData = {
				items: [],
				pagina: 1,
				itemsPorPagina: 10,
				totalPaginas: 1,
				clinica: [],
				nOrden: null,
				fecha: null,
				pacienteERID: patientERID,
				Orden: null
			}

			inFlightRequestsByPatientERID[patientERID] = getExamsResults(postData)
				.then(res => normalizeExamResultsList(res.data?.items))
				.finally(() => {
					delete inFlightRequestsByPatientERID[patientERID]
				})
		}

		inFlightRequestsByPatientERID[patientERID]
			.then(normalizedData => {
				if (!isMounted) return
				setData(normalizedData)
			})
			.catch(err => {
				if (!isMounted) return
				setError(err)
				setData([])
			})
			.finally(() => {
				if (!isMounted) return
				setLoading(false)
			})

		return () => {
			isMounted = false
		}
	}, [patientERID])

	return {
		paginatedResults,
		loading,
		error
	}
}